import { MdOutlineShoppingCart } from "react-icons/md";

const NoCartDataFound = () => {
    return (
        <div className="flex flex-col items-center justify-center text-center min-h-[50vh] ">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-gray-100 mb-6">
                <MdOutlineShoppingCart className="text-4xl text-gray-400" />
            </div>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-3">
                No Cart Data Available
            </h2>

            <p className="text-base md:text-lg text-gray-500 max-w-md leading-relaxed">
                Waiting for items to be added to the cart 🐶
            </p>
        </div>
    );
};

export default NoCartDataFound;
